<template>
    <router-view></router-view>
</template>

<script>

import { auth } from './firebase';


export default {
  name: 'app',
  components: {
  },



  created() {
      const router = this.$router
      let data = this;
      auth.onAuthStateChanged(function(user) {
          if (user) {
             data.$store.state['user'] = user;
            if( router.currentRoute.path == '/login'){
              router.push({ path: '/home' })
            }else{
              if( router.currentRoute.path == '/'){
                router.push({ path: '/home' })
              }
            }  
          } else {
            router.currentRoute.path != '/login'  ?  router.push({ path: '/login' }) : ()=>{}
          }
      });

  },




}
</script>

<style>


</style>
